var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fund-style"},[_c('MoreTitle',{attrs:{"title":"投资目标"}}),_c('div',{staticClass:"row-wrapper"},[_vm._v(" "+_vm._s(_vm.data ?? '--')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }